import { Component, OnInit, ViewChild } from '@angular/core';
import { SocketioService } from '../../dashboard/socketio.service';
import { UserService } from '../user/user.service';
import { SharedService } from '../../shared/shared.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ScheduleService } from '../schedule/schedule.service';
import { ToastsManager } from 'ng2-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-emergency-times',
  templateUrl: './emergency-times.component.html',
  styleUrls: ['./emergency-times.component.scss'],
  providers: [UserService, SharedService, ScheduleService]
})
export class EmergencyTimesComponent implements OnInit {

  @ViewChild('modalList')
  public modalList: ModalDirective;

  public agents: any;
  public schedules: any;
  public agent: any;
  //public load: boolean;

  constructor(private sharedService: SharedService,
    private userService: UserService,
    private scheduleService: ScheduleService,
    public toastr: ToastsManager,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.inicializedData();
  }

  public inicializedData() {
    let cookie = {
      auth_token: this.sharedService.getCookie("auth_token"),
    };
    //this.load = true;
    this.spinner.show();
    this.userService.getAllAgents(cookie).subscribe(
      data => {
        this.agents = data.data;
        //this.load = false;
        this.spinner.hide();
      }, error => {
        //this.load = false;
        this.spinner.hide();
      }
    );

  }

  showModalList(agent: any) {
    //this.load = true;
    this.spinner.show();
    console.log("Id del agente", agent.id);
    if (agent) {
      this.agent = agent;
    }

    let data = {
      auth_token: this.sharedService.getCookie("auth_token"),
      id_agent: this.agent.id
    }
    this.scheduleService._getSchedulesByIdAgent(data).subscribe(
      data => {
        this.schedules = data.data;
        if (data.status) {
          console.log("Horarios cargados correctamente", data);
        } else {
          this.toastr.info("No se encontró horarios para este agente", "Info");
        }
        this.modalList.show();
        //this.load = false;
        this.spinner.hide();
      }, error => {
        console.log("Ocurrio un error al consultar los horarios", error);
        this.toastr.error("Ocurrió un error al consultar los horarios", "Error");
        //this.load = false;
        this.spinner.hide();
      }

    );

  }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/emergency-times/emergency-times.component.ts